const URL_USER = "https://auth.softnik.tech/user/";
const URL_BASE  = "https://api.softnik.tech/";
const URL_BASE_ = "http://localhost:8000/";
const URL_EMPLOYEE = "https://api.softnik.tech/employee";
const URL_EMPLOYEE_HEIGHT = "https://api.softnik.tech/registro";
const URL_DISTRICT = "https://api.softnik.tech/district";
const URL_CITY = "https://api.softnik.tech/city";
const URL_PROVINCE = "https://api.softnik.tech/province";
const URL_PICTURE = "https://www.softnik.cloud/awsProfile/";
const URL_REGISTER = "https://api.softnik.tech/registers";
const URL_ASISTENCIA = "https://api.softnik.tech/registry/signon";
const URL_REGISTRY = "https://api.softnik.tech/registry";
const URL_EMPLOYEE_IMPORT = URL_BASE + "employee/upload";
const URL_EMPLOYEE_IMPORT_VALIDATE = URL_BASE + "employee/upload/validate";
const URL_EMPLOYEE_IMPORT_CONFIRM = URL_BASE + "employee/upload/confirm";
const URL_EMPLOYEE_IMPORT_STATUS = URL_BASE + "employee/upload/status";
const URL_REGISTRY_IMPORT = "https://api.softnik.tech/upload/assistance";
const URL_REGISTRYARRAY = "https://api.softnik.tech/registry/array";
const URL_REGISTRYDELETE = "https://api.softnik.tech/registry/deleteByIds";
const URL_REGISTRYUPDATE = "https://api.softnik.tech/registry/update";
const URL_TICKETS = "https://api.softnik.tech/api/tickets";
const URL_REQUEST = "https://api.softnik.tech/request";
const URL_REQUESTHISTORY = "https://api.softnik.tech/request-history";
const URL_REASON = "https://api.softnik.tech/reason";
const URL_DOCUMENTACION = 'https://api.softnik.tech/documentation';
const URL_EXPORT_WITH_DETAIL = 'https://api.softnik.tech/api/attendance/export/excel/with-detail';
const URL_EXPORT_WITHOUT_DETAIL = 'https://api.softnik.tech/api/attendance/export/excel/without-detail';
const URL_EXPORT_ATTENDANCE_HOURS = 'https://api.softnik.tech/api/attendance';
const URL_ZKTECO = 'https://api.softnik.tech';
const URL_DISPOSITIVOS = "https://api.softnik.tech/api/zkteco/terminals";
const URL_FOLDER = 'https://api.softnik.tech/api/v1/filesystem';
const URL_BIBLIOTECA_SHARE = 'https://api.softnik.tech/api/v1/biblioteca/share';
const URL_STADISTICS = 'https://api.softnik.tech/stadistics';
const URL_STADISTICSARRIVAL = 'https://api.softnik.tech/stadistics/lateArrivals';
const URL_SUSPENSION = URL_BASE + 'suspension';
const URL_ABSENCE = 'https://api.softnik.tech/absence';
const URL_LATE = 'https://api.softnik.tech/late';
const URL_HOLIDAYS = 'https://api.softnik.tech/holidays';
const URL_RECIBOS = 'https://api.softnik.tech/api/v1/recibos';
const URL_CAPACITACIONES = "https://api.softnik.tech/course";
const URL_COURSE_COMPLETED = "https://api.softnik.tech/course-completed";
const URL_UNIFORMS = URL_BASE + "api/uniforms";
const URL_SGI_SAFETY = URL_BASE + "api/sgi/safety-deliveries";
const URL_PROJECT = 'https://api.softnik.tech/plan';
const URL_SHIFT_PATTERNS = 'https://api.softnik.tech/shift-patterns';
const URL_SHIFT_ASSIGNMENTS = 'https://api.softnik.tech/shift-assignments';
const URL_ATTENDANCES = "https://api.softnik.tech/attendances";
const URL_POLITICE = "https://api.softnik.tech/holidays-policy";
const URL_SUPERVISION = URL_BASE + "api/supervision/";
const URL_QUALITY_DASHBOARD = URL_BASE + "api/calidad/dashboard";
const URL_QUALITY_ANALYSIS = URL_BASE + "api/calidad/dashboard/analysis";
const URL_QUALITY_PDF = URL_BASE + "api/calidad/dashboard/pdf";
const URL_SURVEYS = URL_BASE + "api/calidad/surveys";
const URL_SURVEY_SUBMIT = URL_BASE + "api/surveys/submit";
const URL_PAYROLL = "https://payroll.softnik.tech/api/v1/";
const URL_BILLING = "https://billing.softnik.tech/";
const URL_HORAS_CONTROL = URL_BASE + "api/spreadsheet/horas-control";

export {
  URL_BASE,
  URL_ZKTECO,
  URL_POLITICE,
  URL_ATTENDANCES,
  URL_SHIFT_ASSIGNMENTS,
  URL_SHIFT_PATTERNS,
  URL_HOLIDAYS,
  URL_PROJECT,
  URL_UNIFORMS,
  URL_CAPACITACIONES,
  URL_COURSE_COMPLETED,
  URL_LATE,
  URL_RECIBOS,
  URL_ABSENCE,
  URL_CITY,
  URL_PROVINCE,
  URL_PICTURE,
  URL_USER,
  URL_EMPLOYEE,
  URL_DISTRICT,
  URL_REGISTER,
  URL_ASISTENCIA,
  URL_REGISTRY_IMPORT,
  URL_EMPLOYEE_IMPORT,
  URL_EMPLOYEE_IMPORT_VALIDATE,
  URL_EMPLOYEE_IMPORT_CONFIRM,
  URL_EMPLOYEE_IMPORT_STATUS,
  URL_EMPLOYEE_HEIGHT,
  URL_REGISTRYDELETE,
  URL_REQUEST,
  URL_REQUESTHISTORY,
  URL_REASON,
  URL_DOCUMENTACION,
  URL_EXPORT_WITH_DETAIL,
  URL_EXPORT_WITHOUT_DETAIL,
  URL_REGISTRYARRAY,
  URL_REGISTRYUPDATE,
  URL_FOLDER,
  URL_STADISTICS,
  URL_STADISTICSARRIVAL,
  URL_SUSPENSION,
  URL_REGISTRY,
  URL_EXPORT_ATTENDANCE_HOURS,
  URL_TICKETS,
  URL_DISPOSITIVOS,
  URL_SUPERVISION,
  URL_QUALITY_DASHBOARD,
  URL_QUALITY_ANALYSIS,
  URL_QUALITY_PDF,
  URL_SURVEYS,
  URL_SURVEY_SUBMIT,
  URL_PAYROLL,
  URL_SGI_SAFETY,
  URL_BIBLIOTECA_SHARE,
  URL_BILLING,
  URL_HORAS_CONTROL
};
